import { ICON_GRAY } from '@/constants/colors';
import { ReturnComponent } from '@/utils/reactTypes';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import { SvgIconProps, SxProps, Theme } from '@mui/material';
import { useMemo } from 'react';

// Small enough to sit on a line of body text without setting its height.
const INACTIVE_ICON_SIZE = 16;

// `titleAccess` is what names the icon to assistive tech, and to a hover.
const INACTIVE_TITLE = 'Inactive';

type ClinicianInactiveIconProps = Omit<SvgIconProps, 'titleAccess' | 'children'>;

// Marks a clinician who is no longer active where there is no room for a chip.
export const ClinicianInactiveIcon = ({
    sx: providedSx,
    ...rest
}: ClinicianInactiveIconProps): ReturnComponent => {
    const sx = useMemo(
        (): SxProps<Theme> => ({
            fontSize: INACTIVE_ICON_SIZE,
            color: ICON_GRAY,
            ...providedSx,
        }),
        [providedSx],
    );

    return <PersonOffIcon titleAccess={INACTIVE_TITLE} sx={sx} {...rest} />;
};
